import { FloatElementBtn } from '.'

export class HeaderFloatElementBtn extends FloatElementBtn {
  floatElementContainerId: string
  floatElementId: string

  constructor() {
    super()

    this.floatElementContainerId = this.dataset.floatElementId
    this.element = this.firstElementChild
    this.floatElementId = this.element.dataset.headerFloatElementTrigger
  }

  handleMouseLeave = (event): void => {
    event.stopPropagation()
  }

  handleMouseEnter = (event): void => {
    event.stopPropagation()
  }

  trigger = (): void => {}

  setExpand(isExpanded): void {
    this.setAttribute('data-aria-expanded', isExpanded)
  }

  get isOpen(): boolean {
    return this.dataset.ariaExpanded === 'true'
  }
}
